export default __webpack_public_path__ + "static/media/AvenirNextW10-UltraLight.57f8e094.woff";